import { render, staticRenderFns } from "./vFormLIST_MATCH.vue?vue&type=template&id=080bcfb5&scoped=true&"
import script from "./vFormLIST_MATCH.vue?vue&type=script&lang=js&"
export * from "./vFormLIST_MATCH.vue?vue&type=script&lang=js&"
import style0 from "./vFormLIST_MATCH.vue?vue&type=style&index=0&id=080bcfb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080bcfb5",
  null
  
)

export default component.exports